import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";

const LeadStatus = (props) => {
  const { t, data } = props;

  return (
    <>
      {data === 0 && (
        <ColumnButton
          border="#0A4986"
          background="#0A4986"
          marginRight="10px"
          paddingTop="5px"
        >
          {t("LEAD_STATUS_TO_PROCESS")}
        </ColumnButton>
      )}
      {data === 1 && (
        <ColumnButton border="#474747" background="#474747" marginRight="10px">
          {t("LEAD_STATUS_REJECTED")}
        </ColumnButton>
      )}
      {data === 2 && (
        <ColumnButton border="#F08046" background="#F08046" marginRight="10px">
          {t("LEAD_STATUS_IN_PROGRESS")}
        </ColumnButton>
      )}
      {data === 4 && (
        <ColumnButton border="#32A728" background="#32A728" paddingTop="5px">
          {t("LEAD_STATUS_PROCESSED")}
        </ColumnButton>
      )}
    </>
  );
};

LeadStatus.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LeadStatus);
